(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avm-shift-footer"]) return;
  try {
    
function avmCookieSettings() {
  const opener = window.privacyBanner?.showPreferences;
  document.querySelectorAll('.avm-cookie-settings').forEach(button => {
    if (typeof opener === 'function') {
      button.hidden = false;
      if (!button.dataset.bound) {button.dataset.bound = 'true';button.addEventListener('click', () => window.privacyBanner.showPreferences());}
    }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avmCookieSettings, {once:true}); else avmCookieSettings();
window.addEventListener('load', avmCookieSettings, {once:true});
document.addEventListener('shopify:section:load', avmCookieSettings);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
